import { LoadingOutlined } from '@ant-design/icons'
import {
  DECORATION_COUPON,
  DECORATION_GIFT,
  DECORATION_MERCHANT_HONOR,
  DECORATION_MERCHANT_PROMISE,
  DECORATION_MERCHANT_VIDEO
} from '@constant'
import { addImageView } from '@core/utils'
import { isUltimate } from '@merchant-backend/util'
import { getPropertyId } from '@util'
import Spin from 'antd4/lib/spin'
import { inject, observer } from 'mobx-react'
import React, { useEffect, useState } from 'react'
import { PREVIEW, PREVIEW_ALL, PREVIEW_EDITOR } from '../constants'
import { AREALINK } from '../constants/routes'
import { THEME_COLOR } from '../constants/theme'
import Rowbox from '../ShopArea/Common/Rowbox'
import { findStatus } from '../utils/status'
import style from './style.module.less'
import { iframeUrlGenerator } from '@components/LocalMerchant/Decoration/Home/MobileShop/constants/routes'
import Tracker from '@components/Tracker'

// 靠右显示编辑标签的板块
const editingShowRight = {
  [DECORATION_MERCHANT_PROMISE]: 'right',
  [DECORATION_MERCHANT_HONOR]: 'right',
  [DECORATION_COUPON]: 'right',
  [DECORATION_GIFT]: 'right'
}

const IframeShopArea = ({ decorationStore }) => {
  const { allStatus, setStoreData, theme, showAll, mode } = decorationStore

  const [bodyHeight, setBodyHeight] = useState(0)
  const [content, setContent] = useState([])

  useEffect(() => {
    window.addEventListener('message', e => {
      if (e.data.bodyHeight) {
        setBodyHeight(e.data.bodyHeight)
        setContent(e.data.content)
      }
    })
  }, [])

  // 除了基础版普通预览传0以外，其他都是传1
  const editorMode =
    mode === 'preview'
      ? showAll
        ? PREVIEW_ALL
        : isUltimate()
          ? PREVIEW_ALL
          : PREVIEW
      : PREVIEW_EDITOR

  const property_id = getPropertyId()

  // 当处于预览模式和完整版预览模式下，且商家视频不存在的时候，且主题不是黑金时，顶部显示白色
  const backgroundColor =
    editorMode !== 2 &&
    Number(theme) !== 2 &&
    content.findIndex(f => f.id === DECORATION_MERCHANT_VIDEO) === -1
      ? THEME_COLOR[0]
      : THEME_COLOR[theme]

  const onClickRowBox = item => {
    const link = item.link || AREALINK[item.id]
    if (link) {
      window.location.href = link
    }
  }
  return (
    <>
      <div className={style.top} style={{ background: backgroundColor }}>
        {/* 黑色主题时，顶部状态栏用白字透明底图片 */}
        <img
          src={addImageView(
            theme == 2 || theme == 6
              ? 'https://qnm.hunliji.com/Ft8N7RyNTV9kcijtYQRU0tBjvyaU'
              : 'https://qnm.hunliji.com/FhePuEGPjRxh94Oa_E_ySwJ_2MUc',
            750
          )}
        />
      </div>
      <Spin
        indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
        style={{ background: '#fff', maxHeight: 666 }}
        tip="加载中..."
        spinning={bodyHeight <= 0}
      >
        <div className={style.container} style={{ height: bodyHeight }}>
          <iframe
            ref={el => {
              setStoreData({
                iframeShowAreaRef: el
              })
            }}
            style={{ height: bodyHeight }}
            className={style.showArea}
            src={iframeUrlGenerator(property_id, theme, editorMode)}
          />

          {mode === 'editable' &&
            content.map(item => (
              <div
                key={item.id}
                className={style.mark}
                style={{ top: item.top }}
              >
                <Rowbox
                  type={item.id}
                  style={{
                    height: item.height,
                    padding: 0,
                    backgroundColor: 'transparent',
                    marginBottom: 0
                  }}
                  position={editingShowRight[item.id]}
                  status={findStatus(allStatus, item.id)}
                  store={decorationStore}
                  onClick={() => onClickRowBox(item)}
                />
              </div>
            ))}
        </div>
      </Spin>
    </>
  )
}

export default inject('decorationStore')(observer(IframeShopArea))
